// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"efde3b8a","220":"3aed19e4","329":"42a6586a","335":"a9ff8304","356":"6947512e","548":"43270d49","566":"966a56d7","649":"3518df7e","935":"0958c791"}[chunkId] + ".chunk." + chunkId + ".js";
};